/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

import { getFacetRBKey } from '../../utils/filters';

import { StyledFilterButton } from './FilterControls';

const DynamicFormattedMessage = FormattedMessage;

export const StyledFilterCount = styled.span`
  font-weight: 500;
`;

const CountDivider = styled.div`
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.gridV2FloatingControlsText};
  flex-shrink: 0;
  margin-top: 2px;
`;

const LabelAndCount = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const QuickFilter = ({ name, display_name, onClick, numSelectedOptions }) => {
  return (
    <div style={{ position: 'relative' }}>
      <StyledFilterButton type="button" onClick={onClick}>
        <LabelAndCount>
          <DynamicFormattedMessage
            id={`grid_dynamic.${getFacetRBKey(name)}`}
            defaultMessage={display_name}
          />
          {numSelectedOptions > 0 && (
            <>
              <CountDivider />
              <StyledFilterCount>{numSelectedOptions}</StyledFilterCount>
            </>
          )}
        </LabelAndCount>
      </StyledFilterButton>
    </div>
  );
};

QuickFilter.propTypes = {
  display_name: PropTypes.string,
  name: PropTypes.string,
  numSelectedOptions: PropTypes.number,
  onClick: PropTypes.func,
};

export default QuickFilter;
